<div *ngIf="savedSearch.id" [ngClass]="{ 'open': editing }" class="pcg-saved-search-card pcg-contrast-saved-search-card">
    <div class="pcg-saved-search-card__wrapper">
        <div class="pcg-saved-search-card__row">
            <a [href]="savedSearch.url" class="pcg-saved-search-card__link">{{ savedSearch.name }}</a>
            <button
                (click)="onStartEditing()"
                [attr.aria-expanded]="editing"
                aria-label="Edit saved search"
                class="pcg-saved-search-card__edit"
                type="button">
                Edit
            </button>
        </div>
        <p class="pcg-saved-search-card__text">{{ savedSearch.description }}</p>
    </div>
    <div class="pcg-saved-search-card__edit-mode">
        <div class="pcg-saved-search-card__inner">
            <label [for]="'searchTitle-' + savedSearch.id" class="pcg-saved-search-card__label">Search title</label>
            <input [(ngModel)]="formModel.name" [id]="'searchTitle-' + savedSearch.id" class="pcg-saved-search-card__input" type="text">
        </div>
        <div class="pcg-saved-search-card__inner">
            <label [for]="'searchDescription-' + savedSearch.id" class="pcg-saved-search-card__label">Search description</label>
            <input [(ngModel)]="formModel.description" [id]="'searchDescription-' + savedSearch.id" class="pcg-saved-search-card__input" type="text">
        </div>
        <div class="pcg-saved-search-card__actions">
            <button (click)="onSave()" class="pcg-main-button pcg-saved-search-card__btn" type="button">Done</button>
            <button (click)="onDelete()" class="pcg-secondary-button pcg-saved-search-card__btn" type="button">Remove</button>
        </div>
    </div>
</div>
